exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:992px){#page-container{margin-top:64px!important;padding:0!important}.sidebar{margin-top:-64px}.top-bar{height:auto}.checkout-control{width:50%}}.billing{max-width:720px}.billing h1{color:#b2b2b2;border-bottom:5px solid #94040f}.billing h2,.billing h3{color:#94040f}.billing h3{font-weight:700}.billing h4{padding-bottom:.5rem;color:#b2b2b2;font-weight:400;border-bottom:2px solid #b2b2b2}.Table th.tc{text-align:center}.Table th.tr{text-align:right}.Table.billing-overview-table td{border-top:0;padding:0;line-height:1.5}.netto-sum,.overview-value{font-weight:700;color:#94040f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/postcss-loader!./src/pages/checkout/CheckoutPage.scss
// module id = 748
// module chunks = 0